module.exports = __webpack_public_path__ + "static/worldmap-54d466b21bb57b77a148ab3540589498.svg";